// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/root'
import { Route as publicLayoutRouteImport } from './routes/(public)/layout'
import { Route as protectedLayoutRouteImport } from './routes/(protected)/layout'
import { Route as authLayoutRouteImport } from './routes/(auth)/layout'
import { Route as authSignOutRouteRouteImport } from './routes/(auth)/sign-out/route'
import { Route as publicTermsOfServiceRouteRouteImport } from './routes/(public)/terms-of-service/route'
import { Route as publicPrivacyPolicyRouteRouteImport } from './routes/(public)/privacy-policy/route'
import { Route as publicCookiePolicyRouteRouteImport } from './routes/(public)/cookie-policy/route'
import { Route as publicHomeRouteRouteImport } from './routes/(public)/home/route'
import { Route as protectedosLayoutRouteImport } from './routes/(protected)/(os)/layout'
import { Route as protectedResourceOnboardingRouteRouteImport } from './routes/(protected)/resource-onboarding/route'
import { Route as authInvitationRouteRouteImport } from './routes/(auth)/invitation/route'
import { Route as protectedosadminLayoutRouteImport } from './routes/(protected)/(os)/(admin)/layout'
import { Route as protectedosReportsRouteRouteImport } from './routes/(protected)/(os)/reports/route'
import { Route as protectedosMyInvoicesRouteRouteImport } from './routes/(protected)/(os)/my-invoices/route'
import { Route as protectedosDashboardRouteRouteImport } from './routes/(protected)/(os)/dashboard/route'
import { Route as authUpdatePasswordRouteRouteImport } from './routes/(auth)/update-password/route'
import { Route as authSignUpRouteRouteImport } from './routes/(auth)/sign-up/route'
import { Route as authSignInRouteRouteImport } from './routes/(auth)/sign-in/route'
import { Route as authOtpRouteRouteImport } from './routes/(auth)/otp/route'
import { Route as authForgotPasswordRouteRouteImport } from './routes/(auth)/forgot-password/route'
import { Route as authErrorRouteRouteImport } from './routes/(auth)/error/route'
import { Route as protectedosResourcesResourceSlugRouteRouteImport } from './routes/(protected)/(os)/resources/$resourceSlug/route'
import { Route as protectedosResourceInvoicesInvoiceIdRouteRouteImport } from './routes/(protected)/(os)/resource-invoices/$invoiceId/route'
import { Route as protectedosProjectsProjectIdRouteRouteImport } from './routes/(protected)/(os)/projects/$projectId/route'
import { Route as protectedosClientsClientSlugRouteRouteImport } from './routes/(protected)/(os)/clients/$clientSlug/route'
import { Route as protectedosBusinessEntitiesBusinessEntitySlugRouteRouteImport } from './routes/(protected)/(os)/business-entities/$businessEntitySlug/route'
import { Route as protectedosResourcesRouteRouteImport } from './routes/(protected)/(os)/resources/route'
import { Route as protectedosResourceInvoicesRouteRouteImport } from './routes/(protected)/(os)/resource-invoices/route'
import { Route as protectedosProjectsRouteRouteImport } from './routes/(protected)/(os)/projects/route'
import { Route as protectedosClientsRouteRouteImport } from './routes/(protected)/(os)/clients/route'
import { Route as protectedosBusinessEntitiesRouteRouteImport } from './routes/(protected)/(os)/business-entities/route'
import { Route as protectedosadminSystemConfigRouteRouteImport } from './routes/(protected)/(os)/(admin)/system-config/route'
import { Route as protectedosMyInvoicesInvoiceIdRouteRouteImport } from './routes/(protected)/(os)/my-invoices/$invoiceId/route'
import { Route as protectedosResourcesResourceSlugProjectsRouteRouteImport } from './routes/(protected)/(os)/resources/$resourceSlug/projects/route'
import { Route as protectedosResourcesResourceSlugOverviewRouteRouteImport } from './routes/(protected)/(os)/resources/$resourceSlug/overview/route'
import { Route as protectedosResourcesResourceSlugInvoicesRouteRouteImport } from './routes/(protected)/(os)/resources/$resourceSlug/invoices/route'
import { Route as protectedosResourcesResourceSlugDocumentsRouteRouteImport } from './routes/(protected)/(os)/resources/$resourceSlug/documents/route'
import { Route as protectedosProjectsProjectIdOverviewRouteRouteImport } from './routes/(protected)/(os)/projects/$projectId/overview/route'
import { Route as protectedosProjectsProjectIdDocumentsRouteRouteImport } from './routes/(protected)/(os)/projects/$projectId/documents/route'
import { Route as protectedosProjectsProjectIdClientRatesRouteRouteImport } from './routes/(protected)/(os)/projects/$projectId/client-rates/route'
import { Route as protectedosClientsClientSlugResourcesRouteRouteImport } from './routes/(protected)/(os)/clients/$clientSlug/resources/route'
import { Route as protectedosClientsClientSlugProjectsRouteRouteImport } from './routes/(protected)/(os)/clients/$clientSlug/projects/route'
import { Route as protectedosClientsClientSlugOverviewRouteRouteImport } from './routes/(protected)/(os)/clients/$clientSlug/overview/route'
import { Route as protectedosClientsClientSlugMembersRouteRouteImport } from './routes/(protected)/(os)/clients/$clientSlug/members/route'
import { Route as protectedosBusinessEntitiesBusinessEntitySlugOverviewRouteRouteImport } from './routes/(protected)/(os)/business-entities/$businessEntitySlug/overview/route'
import { Route as protectedosBusinessEntitiesBusinessEntitySlugMembersRouteRouteImport } from './routes/(protected)/(os)/business-entities/$businessEntitySlug/members/route'
import { Route as protectedosBusinessEntitiesBusinessEntitySlugFinancialRouteRouteImport } from './routes/(protected)/(os)/business-entities/$businessEntitySlug/financial/route'
import { Route as protectedosadminSystemConfigUsersRouteRouteImport } from './routes/(protected)/(os)/(admin)/system-config/users/route'
import { Route as protectedosadminSystemConfigLocalesRouteRouteImport } from './routes/(protected)/(os)/(admin)/system-config/locales/route'
import { Route as protectedosadminSystemConfigLanguageProficiencyLevelsRouteRouteImport } from './routes/(protected)/(os)/(admin)/system-config/language-proficiency-levels/route'
import { Route as protectedosadminSystemConfigInvoiceItemsRouteRouteImport } from './routes/(protected)/(os)/(admin)/system-config/invoice-items/route'
import { Route as protectedosadminSystemConfigCurrenciesRouteRouteImport } from './routes/(protected)/(os)/(admin)/system-config/currencies/route'

const publicLayoutRoute = publicLayoutRouteImport.update({
            id: '/_public-layout',getParentRoute: () => rootRouteImport
          })
const protectedLayoutRoute = protectedLayoutRouteImport.update({
            id: '/_protected-layout',getParentRoute: () => rootRouteImport
          })
const authLayoutRoute = authLayoutRouteImport.update({
            id: '/_auth-layout',getParentRoute: () => rootRouteImport
          })
const authSignOutRouteRoute = authSignOutRouteRouteImport.update({
            id: '/auth/sign-out',path: '/auth/sign-out',getParentRoute: () => rootRouteImport
          })
const publicTermsOfServiceRouteRoute = publicTermsOfServiceRouteRouteImport.update({
            id: '/terms-of-service',path: '/terms-of-service',getParentRoute: () => publicLayoutRoute
          })
const publicPrivacyPolicyRouteRoute = publicPrivacyPolicyRouteRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => publicLayoutRoute
          })
const publicCookiePolicyRouteRoute = publicCookiePolicyRouteRouteImport.update({
            id: '/cookie-policy',path: '/cookie-policy',getParentRoute: () => publicLayoutRoute
          })
const publicHomeRouteRoute = publicHomeRouteRouteImport.update({
            id: '/',path: '/',getParentRoute: () => publicLayoutRoute
          })
const protectedosLayoutRoute = protectedosLayoutRouteImport.update({
            id: '/_os-layout',getParentRoute: () => protectedLayoutRoute
          })
const protectedResourceOnboardingRouteRoute = protectedResourceOnboardingRouteRouteImport.update({
            id: '/resource-onboarding',path: '/resource-onboarding',getParentRoute: () => protectedLayoutRoute
          })
const authInvitationRouteRoute = authInvitationRouteRouteImport.update({
            id: '/invitation',path: '/invitation',getParentRoute: () => authLayoutRoute
          })
const protectedosadminLayoutRoute = protectedosadminLayoutRouteImport.update({
            id: '/_admin-layout',getParentRoute: () => protectedosLayoutRoute
          })
const protectedosReportsRouteRoute = protectedosReportsRouteRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => protectedosLayoutRoute
          })
const protectedosMyInvoicesRouteRoute = protectedosMyInvoicesRouteRouteImport.update({
            id: '/my-invoices',path: '/my-invoices',getParentRoute: () => protectedosLayoutRoute
          })
const protectedosDashboardRouteRoute = protectedosDashboardRouteRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => protectedosLayoutRoute
          })
const authUpdatePasswordRouteRoute = authUpdatePasswordRouteRouteImport.update({
            id: '/auth/update-password',path: '/auth/update-password',getParentRoute: () => authLayoutRoute
          })
const authSignUpRouteRoute = authSignUpRouteRouteImport.update({
            id: '/auth/sign-up',path: '/auth/sign-up',getParentRoute: () => authLayoutRoute
          })
const authSignInRouteRoute = authSignInRouteRouteImport.update({
            id: '/auth/sign-in',path: '/auth/sign-in',getParentRoute: () => authLayoutRoute
          })
const authOtpRouteRoute = authOtpRouteRouteImport.update({
            id: '/auth/otp',path: '/auth/otp',getParentRoute: () => authLayoutRoute
          })
const authForgotPasswordRouteRoute = authForgotPasswordRouteRouteImport.update({
            id: '/auth/forgot-password',path: '/auth/forgot-password',getParentRoute: () => authLayoutRoute
          })
const authErrorRouteRoute = authErrorRouteRouteImport.update({
            id: '/auth/error',path: '/auth/error',getParentRoute: () => authLayoutRoute
          })
const protectedosResourcesResourceSlugRouteRoute = protectedosResourcesResourceSlugRouteRouteImport.update({
            id: '/resources/$resourceSlug',path: '/resources/$resourceSlug',getParentRoute: () => protectedosLayoutRoute
          })
const protectedosResourceInvoicesInvoiceIdRouteRoute = protectedosResourceInvoicesInvoiceIdRouteRouteImport.update({
            id: '/resource-invoices/$invoiceId',path: '/resource-invoices/$invoiceId',getParentRoute: () => protectedosLayoutRoute
          })
const protectedosProjectsProjectIdRouteRoute = protectedosProjectsProjectIdRouteRouteImport.update({
            id: '/projects/$projectId',path: '/projects/$projectId',getParentRoute: () => protectedosLayoutRoute
          })
const protectedosClientsClientSlugRouteRoute = protectedosClientsClientSlugRouteRouteImport.update({
            id: '/clients/$clientSlug',path: '/clients/$clientSlug',getParentRoute: () => protectedosLayoutRoute
          })
const protectedosBusinessEntitiesBusinessEntitySlugRouteRoute = protectedosBusinessEntitiesBusinessEntitySlugRouteRouteImport.update({
            id: '/business-entities/$businessEntitySlug',path: '/business-entities/$businessEntitySlug',getParentRoute: () => protectedosLayoutRoute
          })
const protectedosResourcesRouteRoute = protectedosResourcesRouteRouteImport.update({
            id: '/resources/',path: '/resources/',getParentRoute: () => protectedosLayoutRoute
          })
const protectedosResourceInvoicesRouteRoute = protectedosResourceInvoicesRouteRouteImport.update({
            id: '/resource-invoices/',path: '/resource-invoices/',getParentRoute: () => protectedosLayoutRoute
          })
const protectedosProjectsRouteRoute = protectedosProjectsRouteRouteImport.update({
            id: '/projects/',path: '/projects/',getParentRoute: () => protectedosLayoutRoute
          })
const protectedosClientsRouteRoute = protectedosClientsRouteRouteImport.update({
            id: '/clients/',path: '/clients/',getParentRoute: () => protectedosLayoutRoute
          })
const protectedosBusinessEntitiesRouteRoute = protectedosBusinessEntitiesRouteRouteImport.update({
            id: '/business-entities/',path: '/business-entities/',getParentRoute: () => protectedosLayoutRoute
          })
const protectedosadminSystemConfigRouteRoute = protectedosadminSystemConfigRouteRouteImport.update({
            id: '/system-config',path: '/system-config',getParentRoute: () => protectedosadminLayoutRoute
          })
const protectedosMyInvoicesInvoiceIdRouteRoute = protectedosMyInvoicesInvoiceIdRouteRouteImport.update({
            id: '/$invoiceId',path: '/$invoiceId',getParentRoute: () => protectedosMyInvoicesRouteRoute
          })
const protectedosResourcesResourceSlugProjectsRouteRoute = protectedosResourcesResourceSlugProjectsRouteRouteImport.update({
            id: '/projects',path: '/projects',getParentRoute: () => protectedosResourcesResourceSlugRouteRoute
          })
const protectedosResourcesResourceSlugOverviewRouteRoute = protectedosResourcesResourceSlugOverviewRouteRouteImport.update({
            id: '/overview',path: '/overview',getParentRoute: () => protectedosResourcesResourceSlugRouteRoute
          })
const protectedosResourcesResourceSlugInvoicesRouteRoute = protectedosResourcesResourceSlugInvoicesRouteRouteImport.update({
            id: '/invoices',path: '/invoices',getParentRoute: () => protectedosResourcesResourceSlugRouteRoute
          })
const protectedosResourcesResourceSlugDocumentsRouteRoute = protectedosResourcesResourceSlugDocumentsRouteRouteImport.update({
            id: '/documents',path: '/documents',getParentRoute: () => protectedosResourcesResourceSlugRouteRoute
          })
const protectedosProjectsProjectIdOverviewRouteRoute = protectedosProjectsProjectIdOverviewRouteRouteImport.update({
            id: '/overview',path: '/overview',getParentRoute: () => protectedosProjectsProjectIdRouteRoute
          })
const protectedosProjectsProjectIdDocumentsRouteRoute = protectedosProjectsProjectIdDocumentsRouteRouteImport.update({
            id: '/documents',path: '/documents',getParentRoute: () => protectedosProjectsProjectIdRouteRoute
          })
const protectedosProjectsProjectIdClientRatesRouteRoute = protectedosProjectsProjectIdClientRatesRouteRouteImport.update({
            id: '/client-rates',path: '/client-rates',getParentRoute: () => protectedosProjectsProjectIdRouteRoute
          })
const protectedosClientsClientSlugResourcesRouteRoute = protectedosClientsClientSlugResourcesRouteRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => protectedosClientsClientSlugRouteRoute
          })
const protectedosClientsClientSlugProjectsRouteRoute = protectedosClientsClientSlugProjectsRouteRouteImport.update({
            id: '/projects',path: '/projects',getParentRoute: () => protectedosClientsClientSlugRouteRoute
          })
const protectedosClientsClientSlugOverviewRouteRoute = protectedosClientsClientSlugOverviewRouteRouteImport.update({
            id: '/overview',path: '/overview',getParentRoute: () => protectedosClientsClientSlugRouteRoute
          })
const protectedosClientsClientSlugMembersRouteRoute = protectedosClientsClientSlugMembersRouteRouteImport.update({
            id: '/members',path: '/members',getParentRoute: () => protectedosClientsClientSlugRouteRoute
          })
const protectedosBusinessEntitiesBusinessEntitySlugOverviewRouteRoute = protectedosBusinessEntitiesBusinessEntitySlugOverviewRouteRouteImport.update({
            id: '/overview',path: '/overview',getParentRoute: () => protectedosBusinessEntitiesBusinessEntitySlugRouteRoute
          })
const protectedosBusinessEntitiesBusinessEntitySlugMembersRouteRoute = protectedosBusinessEntitiesBusinessEntitySlugMembersRouteRouteImport.update({
            id: '/members',path: '/members',getParentRoute: () => protectedosBusinessEntitiesBusinessEntitySlugRouteRoute
          })
const protectedosBusinessEntitiesBusinessEntitySlugFinancialRouteRoute = protectedosBusinessEntitiesBusinessEntitySlugFinancialRouteRouteImport.update({
            id: '/financial',path: '/financial',getParentRoute: () => protectedosBusinessEntitiesBusinessEntitySlugRouteRoute
          })
const protectedosadminSystemConfigUsersRouteRoute = protectedosadminSystemConfigUsersRouteRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => protectedosadminSystemConfigRouteRoute
          })
const protectedosadminSystemConfigLocalesRouteRoute = protectedosadminSystemConfigLocalesRouteRouteImport.update({
            id: '/locales',path: '/locales',getParentRoute: () => protectedosadminSystemConfigRouteRoute
          })
const protectedosadminSystemConfigLanguageProficiencyLevelsRouteRoute = protectedosadminSystemConfigLanguageProficiencyLevelsRouteRouteImport.update({
            id: '/language-proficiency-levels',path: '/language-proficiency-levels',getParentRoute: () => protectedosadminSystemConfigRouteRoute
          })
const protectedosadminSystemConfigInvoiceItemsRouteRoute = protectedosadminSystemConfigInvoiceItemsRouteRouteImport.update({
            id: '/invoice-items',path: '/invoice-items',getParentRoute: () => protectedosadminSystemConfigRouteRoute
          })
const protectedosadminSystemConfigCurrenciesRouteRoute = protectedosadminSystemConfigCurrenciesRouteRouteImport.update({
            id: '/currencies',path: '/currencies',getParentRoute: () => protectedosadminSystemConfigRouteRoute
          })





const authLayoutRouteChildren = {
  authInvitationRouteRoute: authInvitationRouteRoute,authErrorRouteRoute: authErrorRouteRoute,authForgotPasswordRouteRoute: authForgotPasswordRouteRoute,authOtpRouteRoute: authOtpRouteRoute,authSignInRouteRoute: authSignInRouteRoute,authSignUpRouteRoute: authSignUpRouteRoute,authUpdatePasswordRouteRoute: authUpdatePasswordRouteRoute
}

const authLayoutRouteWithChildren = authLayoutRoute._addFileChildren(authLayoutRouteChildren)




const protectedosMyInvoicesRouteRouteChildren = {
  protectedosMyInvoicesInvoiceIdRouteRoute: protectedosMyInvoicesInvoiceIdRouteRoute
}

const protectedosMyInvoicesRouteRouteWithChildren = protectedosMyInvoicesRouteRoute._addFileChildren(protectedosMyInvoicesRouteRouteChildren)




const protectedosadminSystemConfigRouteRouteChildren = {
  protectedosadminSystemConfigCurrenciesRouteRoute: protectedosadminSystemConfigCurrenciesRouteRoute,protectedosadminSystemConfigInvoiceItemsRouteRoute: protectedosadminSystemConfigInvoiceItemsRouteRoute,protectedosadminSystemConfigLanguageProficiencyLevelsRouteRoute: protectedosadminSystemConfigLanguageProficiencyLevelsRouteRoute,protectedosadminSystemConfigLocalesRouteRoute: protectedosadminSystemConfigLocalesRouteRoute,protectedosadminSystemConfigUsersRouteRoute: protectedosadminSystemConfigUsersRouteRoute
}

const protectedosadminSystemConfigRouteRouteWithChildren = protectedosadminSystemConfigRouteRoute._addFileChildren(protectedosadminSystemConfigRouteRouteChildren)



const protectedosadminLayoutRouteChildren = {
  protectedosadminSystemConfigRouteRoute: protectedosadminSystemConfigRouteRouteWithChildren
}

const protectedosadminLayoutRouteWithChildren = protectedosadminLayoutRoute._addFileChildren(protectedosadminLayoutRouteChildren)




const protectedosBusinessEntitiesBusinessEntitySlugRouteRouteChildren = {
  protectedosBusinessEntitiesBusinessEntitySlugFinancialRouteRoute: protectedosBusinessEntitiesBusinessEntitySlugFinancialRouteRoute,protectedosBusinessEntitiesBusinessEntitySlugMembersRouteRoute: protectedosBusinessEntitiesBusinessEntitySlugMembersRouteRoute,protectedosBusinessEntitiesBusinessEntitySlugOverviewRouteRoute: protectedosBusinessEntitiesBusinessEntitySlugOverviewRouteRoute
}

const protectedosBusinessEntitiesBusinessEntitySlugRouteRouteWithChildren = protectedosBusinessEntitiesBusinessEntitySlugRouteRoute._addFileChildren(protectedosBusinessEntitiesBusinessEntitySlugRouteRouteChildren)




const protectedosClientsClientSlugRouteRouteChildren = {
  protectedosClientsClientSlugMembersRouteRoute: protectedosClientsClientSlugMembersRouteRoute,protectedosClientsClientSlugOverviewRouteRoute: protectedosClientsClientSlugOverviewRouteRoute,protectedosClientsClientSlugProjectsRouteRoute: protectedosClientsClientSlugProjectsRouteRoute,protectedosClientsClientSlugResourcesRouteRoute: protectedosClientsClientSlugResourcesRouteRoute
}

const protectedosClientsClientSlugRouteRouteWithChildren = protectedosClientsClientSlugRouteRoute._addFileChildren(protectedosClientsClientSlugRouteRouteChildren)




const protectedosProjectsProjectIdRouteRouteChildren = {
  protectedosProjectsProjectIdClientRatesRouteRoute: protectedosProjectsProjectIdClientRatesRouteRoute,protectedosProjectsProjectIdDocumentsRouteRoute: protectedosProjectsProjectIdDocumentsRouteRoute,protectedosProjectsProjectIdOverviewRouteRoute: protectedosProjectsProjectIdOverviewRouteRoute
}

const protectedosProjectsProjectIdRouteRouteWithChildren = protectedosProjectsProjectIdRouteRoute._addFileChildren(protectedosProjectsProjectIdRouteRouteChildren)




const protectedosResourcesResourceSlugRouteRouteChildren = {
  protectedosResourcesResourceSlugDocumentsRouteRoute: protectedosResourcesResourceSlugDocumentsRouteRoute,protectedosResourcesResourceSlugInvoicesRouteRoute: protectedosResourcesResourceSlugInvoicesRouteRoute,protectedosResourcesResourceSlugOverviewRouteRoute: protectedosResourcesResourceSlugOverviewRouteRoute,protectedosResourcesResourceSlugProjectsRouteRoute: protectedosResourcesResourceSlugProjectsRouteRoute
}

const protectedosResourcesResourceSlugRouteRouteWithChildren = protectedosResourcesResourceSlugRouteRoute._addFileChildren(protectedosResourcesResourceSlugRouteRouteChildren)



const protectedosLayoutRouteChildren = {
  protectedosDashboardRouteRoute: protectedosDashboardRouteRoute,protectedosMyInvoicesRouteRoute: protectedosMyInvoicesRouteRouteWithChildren,protectedosReportsRouteRoute: protectedosReportsRouteRoute,protectedosadminLayoutRoute: protectedosadminLayoutRouteWithChildren,protectedosBusinessEntitiesRouteRoute: protectedosBusinessEntitiesRouteRoute,protectedosClientsRouteRoute: protectedosClientsRouteRoute,protectedosProjectsRouteRoute: protectedosProjectsRouteRoute,protectedosResourceInvoicesRouteRoute: protectedosResourceInvoicesRouteRoute,protectedosResourcesRouteRoute: protectedosResourcesRouteRoute,protectedosBusinessEntitiesBusinessEntitySlugRouteRoute: protectedosBusinessEntitiesBusinessEntitySlugRouteRouteWithChildren,protectedosClientsClientSlugRouteRoute: protectedosClientsClientSlugRouteRouteWithChildren,protectedosProjectsProjectIdRouteRoute: protectedosProjectsProjectIdRouteRouteWithChildren,protectedosResourceInvoicesInvoiceIdRouteRoute: protectedosResourceInvoicesInvoiceIdRouteRoute,protectedosResourcesResourceSlugRouteRoute: protectedosResourcesResourceSlugRouteRouteWithChildren
}

const protectedosLayoutRouteWithChildren = protectedosLayoutRoute._addFileChildren(protectedosLayoutRouteChildren)



const protectedLayoutRouteChildren = {
  protectedResourceOnboardingRouteRoute: protectedResourceOnboardingRouteRoute,protectedosLayoutRoute: protectedosLayoutRouteWithChildren
}

const protectedLayoutRouteWithChildren = protectedLayoutRoute._addFileChildren(protectedLayoutRouteChildren)




const publicLayoutRouteChildren = {
  publicHomeRouteRoute: publicHomeRouteRoute,publicCookiePolicyRouteRoute: publicCookiePolicyRouteRoute,publicPrivacyPolicyRouteRoute: publicPrivacyPolicyRouteRoute,publicTermsOfServiceRouteRoute: publicTermsOfServiceRouteRoute
}

const publicLayoutRouteWithChildren = publicLayoutRoute._addFileChildren(publicLayoutRouteChildren)

const rootRouteChildren = {
  authLayoutRoute: authLayoutRouteWithChildren,protectedLayoutRoute: protectedLayoutRouteWithChildren,publicLayoutRoute: publicLayoutRouteWithChildren,authSignOutRouteRoute: authSignOutRouteRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)